// @flow
/* eslint-disable react/button-has-type */
import React from 'react';

type Props = {
  children: any,
  disabled?: boolean,
  modifier?: 'primary' | 'secondary' | 'outline' | 'fb' | 'google',
  loading?: boolean,
  hideTextDuringLoading?: boolean,
  size?: 'small' | 'large',
  width?: 'full' | 'narrow',
  additionalClasses?: string,
  onClick?: () => void,
  type?: 'button' | 'submit' | 'reset',
  cypress?: string | null
};

const Button = ({
  children,
  cypress = null,
  modifier = 'primary',
  hideTextDuringLoading = false,
  size = null,
  disabled = false,
  loading = false,
  additionalClasses = '',
  width = 'full',
  type = 'button',
  onClick = () => {}
}: Props) => {
  const sizeClass = size ? `bt--${size}` : '';
  const loadingClass = loading ? 'is-loading' : '';
  const hideTextLoadingClass =
    loading && hideTextDuringLoading ? 'hide-text' : '';

  return (
    <button
      type={type}
      onClick={onClick}
      className={`bt bt--${modifier} bt--${loadingClass} bt--${hideTextLoadingClass} bt--${width} ${sizeClass} ${additionalClasses}`}
      disabled={disabled}
      data-cy={cypress}
    >
      {children}
    </button>
  );
};

export default Button;
